import { DATE_PRESET } from './searchPrefsConstants';

function toIsoDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function startOfWeek(date) {
  const copy = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const day = copy.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  copy.setDate(copy.getDate() + diff);
  return copy;
}

function endOfWeek(date) {
  const start = startOfWeek(date);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return end;
}

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

/**
 * @param {string|null|undefined} preset
 * @returns {{ dateFilterMode: string, queryFromDay: string, queryToDay: string }}
 */
export function datePresetToFilterDates(preset) {
  if (!preset) {
    return { dateFilterMode: 'any', queryFromDay: '', queryToDay: '' };
  }

  const now = new Date();

  if (preset === DATE_PRESET.TODAY) {
    const today = toIsoDate(now);
    return { dateFilterMode: 'range', queryFromDay: today, queryToDay: today };
  }

  if (preset === DATE_PRESET.THIS_WEEK) {
    return {
      dateFilterMode: 'range',
      queryFromDay: toIsoDate(startOfWeek(now)),
      queryToDay: toIsoDate(endOfWeek(now)),
    };
  }

  if (preset === DATE_PRESET.THIS_MONTH) {
    return {
      dateFilterMode: 'range',
      queryFromDay: toIsoDate(startOfMonth(now)),
      queryToDay: toIsoDate(endOfMonth(now)),
    };
  }

  return { dateFilterMode: 'any', queryFromDay: '', queryToDay: '' };
}

/**
 * Detect a backend date preset from current filter date fields.
 * @returns {string|null}
 */
export function detectDatePreset(dateFilterMode, queryFromDay, queryToDay) {
  if (dateFilterMode === 'any' || !queryFromDay || !queryToDay) {
    return null;
  }

  const candidates = [DATE_PRESET.TODAY, DATE_PRESET.THIS_WEEK, DATE_PRESET.THIS_MONTH];
  for (const preset of candidates) {
    const { queryFromDay: from, queryToDay: to } = datePresetToFilterDates(preset);
    if (from === queryFromDay && to === queryToDay) {
      return preset;
    }
  }

  return null;
}
